var map = {
	"./Ajax_Amsterdam_1928-1991—2025_Logo.svg": 1454,
	"./Arsenal_FC_2002.svg": 3227,
	"./Aston_Villa_FC_2024.svg": 6135,
	"./Atalanta_Bergame_2024.svg": 3143,
	"./Athletic_Club_1995.svg": 3218,
	"./Atletico Madrid_2024.svg": 9455,
	"./BORUSSIA DORTMUND.png": 5861,
	"./BSC_Young_Boys.svg": 5421,
	"./Barcelone.svg": 1771,
	"./Basel_2023.svg": 3111,
	"./Bayer_04_Leverkusen_(logo).svg": 7094,
	"./Bayern_München_logo_(2024).svg": 7995,
	"./Benfica_(3_Stars).svg": 4987,
	"./Bodø_Glimt.svg": 9333,
	"./Bologna.png": 9336,
	"./Braga_2024.png": 9660,
	"./Cagliari_Calcio_1920_logo.svg": 9991,
	"./Club_Brugge_KV_2024.svg": 3080,
	"./Como_-_logo_(Italy,_2019-).svg": 3703,
	"./Copenhagen_logo.svg": 2902,
	"./Cremonese_2018.svg": 2499,
	"./Eintracht_Francfort.svg": 3636,
	"./Empoli_FC_2021.svg": 7288,
	"./Fenerbahçe_SK_(5_Stars).svg": 3305,
	"./Ferencváros_TC.svg": 7898,
	"./Feyenoord_Rotterdam_2024.svg": 5425,
	"./Fiorentina_2022.svg": 3968,
	"./Frosinone_Calcio_2011.svg": 2954,
	"./Genoa_CFC_-_2022.svg": 1202,
	"./Hellas_Verona_FC_logo_(2020).svg": 8461,
	"./INTER.png": 2916,
	"./Inter-Milan-logo-1-512x512.png": 1083,
	"./Juventus_(white_on_black).svg": 8339,
	"./KRC_Genk_2021.svg": 9978,
	"./LOSC_Lille_2018.svg": 6432,
	"./Lazio.svg": 173,
	"./Lecce_2023.svg": 7808,
	"./Liverpool_FC_2012.svg": 8540,
	"./Logo_Udinese_Calcio_2010.svg": 8837,
	"./Logo_Villarreal_CF_2009.svg": 4254,
	"./Manchester_City_2016.svg": 6100,
	"./Manchester_United_FC.svg": 8150,
	"./Midtjylland_2025.svg": 5254,
	"./Milan.svg": 263,
	"./Modena_FC_-_2022.svg": 6077,
	"./Monaco_FC_2021.svg": 6089,
	"./Monza_2019.svg": 5108,
	"./Nantes_(avec_fond)_-_2019.svg": 1115,
	"./Napoli_2024.svg": 7440,
	"./Newcastle_United_FC.svg": 934,
	"./Nottingham_Forest_FC.svg": 6725,
	"./Olympiakos_2024.svg": 8591,
	"./Olympique_de_Marseille.svg": 7878,
	"./PSV.svg": 8751,
	"./Palermo_FC_-_2024.svg": 1251,
	"./Panathinaikos_F.C._logo.svg": 2604,
	"./Paris_Saint-Germain_2024.svg": 1352,
	"./Parma_Calcio_1913.svg": 6006,
	"./Pisa_SC_2024.svg": 7369,
	"./Porto.svg": 7732,
	"./Qarabağ_FK_2024.svg": 9176,
	"./Real_Madrid.svg": 4044,
	"./Real_betis_logo.svg": 3622,
	"./Reggiana_1919_(2024).svg": 2591,
	"./Roma_Logo_2017.svg": 3592,
	"./Royale_Union_Saint-Gilloise_2025.svg": 5333,
	"./SC_Freiburg_(logo).svg": 4722,
	"./Sampdoria_1997.svg": 8357,
	"./Sassuolo_2024.svg": 7172,
	"./Slavia_2024.svg": 9297,
	"./Spezia_Calcio_2025.svg": 6368,
	"./Stade_Rennais_FC.svg": 8056,
	"./Standard_de_Liège_2019.svg": 5372,
	"./Stuttgart_1893_Logo.svg": 8010,
	"./Séville_FC.svg": 7198,
	"./Torino_FC_2024.svg": 7816,
	"./Tottenham_Hotspur_Football_Club_2024.svg": 4646,
	"./Viktoria PlzenCVP_official_logo.svg": 387,
	"./ac-milan.png": 2496,
	"./as_roma-logo_brandlogos.net_50bhu-512x656.png": 9340,
	"./as_roma_1961-1977-logo_brandlogos.net_yjjmu-512x613.png": 1267,
	"./atalanta_bc-logo_brandlogos.net_yq22a-512x839.png": 8444,
	"./bologna_fc_1909-logo_brandlogos.net_vf54h-512x744.png": 1935,
	"./cagliari-calcio-logo-512x512.png": 3213,
	"./carpi_fc_1909-logo_brandlogos.net_lbrcm-512x573.png": 407,
	"./empoli_fc_2013-2021-logo_brandlogos.net_eah2b-512x598.png": 9456,
	"./fiorentina-logo-vector.png": 5567,
	"./genoa-cfc-vector-logo.png": 6585,
	"./hellas_verona_fc-logo_brandlogos.net_0b2nl-512x512.png": 1388,
	"./juventus_fc-brandlogo.net_-512x512.png": 6446,
	"./spezia-calcio-logo-512x512.png": 6595,
	"./ss-lazio-roma-vector-logo.png": 7056,
	"./ssc-napoli-vector-logo-512x512.png": 4791,
	"./torino-logo-vector.png": 8197,
	"./udinese-calcio-vector-logo.png": 7611,
	"./us_cremonese-logo_brandlogos.net_sff88-512x485.png": 6119,
	"./us_sassuolo_calcio-logo_brandlogos.net_wl1mr-512x561.png": 304,
	"./venezia_fc-brandlogo.net_-512x512.png": 8738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8587;